import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import TestimonialSwiper from "../../../V2/Sections/TestimonialSwiper"

import { TestimonialProps } from "@components/V2/Sections/TestimonialSwiper/TestimonialCard"

/*
  TODO: if we keep this component after experiment, we should consider using SocialProofing from V2/Sections
  and refactor SocialProofing to fulfil this use case.
*/

const TESTIMONIALS: TestimonialProps[] = [
  {
    rating: 5,
    reviewText:
      "Staff tips increased dramatically once we started using Counter.",
    reviewer: {
      icon: "https://a.storyblok.com/f/111633/88x88/ff7dc39347/testimonial-1.png",
      name: "Teddy",
      businessName: "Smoothie on the Go",
    },
  },
  {
    rating: 5,
    reviewText:
      "I’ve replaced using old-school invoicing books with Counter. The biggest benefit has been the time it’s giving me back.",
    reviewer: {
      icon: "https://a.storyblok.com/f/111633/88x88/5d4ba87517/testimonial-2.png",
      name: "Catherine",
      businessName: "The Hideaway",
    },
  },
  {
    rating: 5,
    reviewText:
      "The order printing has completely changed the way I have managed my workflow. It’s been a game changer.",
    reviewer: {
      icon: "https://a.storyblok.com/f/111633/88x88/3f9aa36ccb/testimonial-3.png",
      name: "TY",
      businessName: "Ekhaya Coffee",
    },
  },
  {
    rating: 5,
    reviewText:
      "It's so easy to use. It looks professional and makes my prices and business more credible. ",
    reviewer: {
      icon: "https://a.storyblok.com/f/111633/88x88/b253ba2419/testimonial-4.png",
      name: "Linda",
      businessName: "Bernina",
    },
  },
]

const TestimonialSwiperStoryblok = ({
  blok,
}: Storyblok.BlokProps<Storyblok.TestimonialSwiper>) => {
  const blokHeading = blok.heading?.[0] || ({} as Storyblok.LayoutHeading)

  const storyblokTestimonials: TestimonialProps[] | undefined =
    blok.testimonials?.map((testimonial) => {
      const ratingNumber = Number(testimonial.rating)
      return {
        rating: Number.isFinite(ratingNumber) ? ratingNumber : 5,
        reviewText: testimonial.description,
        reviewer: {
          icon: testimonial.image?.filename,
          name: testimonial.name,
          businessName: testimonial.businessName ?? "",
        },
      }
    })

  const testimonialItems =
    storyblokTestimonials && storyblokTestimonials.length > 0
      ? storyblokTestimonials
      : TESTIMONIALS

  /*
    Testimonials are duplicated for continuous scrolling without inconsistent spacing.
    Length of the array must always be an even number. Length can be shorter or longer depending on
    the width of a single testimonials container and the largest screen width we want to support.
  */
  const testimonials = [...testimonialItems, ...testimonialItems]

  const priceAsNumber =
    blok.price !== undefined && blok.price !== null && `${blok.price}` !== ""
      ? Number(blok.price)
      : undefined

  return (
    <TestimonialSwiper
      backgroundColor={blok.backgroundColor}
      cardColor={blok.cardColor}
      cardBorderColor={blok.cardBorderColor}
      cardDropShadow={blok.cardDropShadow}
      testimonials={testimonials}
      hideStars={blok.hideStars}
      heading={{
        ...blokHeading,
        size: blokHeading?.size || "large",
        alignment: blokHeading?.alignment || "center",
        mobileAlignment: blokHeading?.mobileAlignment || "center",
        callout: blokHeading?.callout?.[0],
      }}
      price={priceAsNumber}
      priceDescription={blok.priceDescription}
      ctaText={blok.ctaText}
      ctaLink={blok.ctaLink}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default TestimonialSwiperStoryblok
